// Tag for graphql format
const gql = String.raw;

// Fragments
import {
	CallActivityPerformanceFragment,
	CommissionTiersFragment,
	ELRAndHROBonusFragment,
	InputValueFragment,
	LongevityFragment,
	MetricFragment,
	TopPerformerBonusFragment,
} from "@PayPlans/api/fragments/commons";

import { CustomerSatisfactionFragment } from "@PayPlans/api/fragments/salesAssociates";
import {
	AdvisorDefaultFragment,
	FollowUpPerformanceBonusFragment,
	RetentionFragment,
	HolidayPayFragment,
} from "@PayPlans/api/fragments/service/advisors";

export const onCreateAdvisorPayPlan = gql`
	subscription onCreateAdvisorPayPlan($locationId: String, $position: String) {
		onCreateAdvisorPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			default {
				...AdvisorDefault
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			customerSatisfaction {
				...CustomerSatisfaction
			}
			longevity {
				...Longevity
			}
			retentionPay {
				...Retention
			}
			holidayPay {
				...HolidayPay
			}
			topAdvisorsBonus {
				...TopPerformerBonus
			}
			elr {
				...ELRAndHROBonus
			}
			hro {
				...ELRAndHROBonus
			}
			locked
			available
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${AdvisorDefaultFragment}
	${CallActivityPerformanceFragment}
	${CommissionTiersFragment}
	${CustomerSatisfactionFragment}
	${LongevityFragment}
	${InputValueFragment}
	${MetricFragment}
	${TopPerformerBonusFragment}
	${ELRAndHROBonusFragment}
	${RetentionFragment}
	${HolidayPayFragment}
`;

export const onCloneAdvisorPayPlan = gql`
	subscription onCloneAdvisorPayPlan($locationId: String, $position: String) {
		onCloneAdvisorPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
		}
	}
`;

export const onUpdateAdvisorAvailablePayPlan = gql`
	subscription onUpdateAdvisorAvailablePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateAdvisorAvailablePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteAdvisorPayPlan = gql`
	subscription onDeleteAdvisorPayPlan($locationId: String, $position: String) {
		onDeleteAdvisorPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
		}
	}
`;

export const onUpdateAdvisorPayPlan = gql`
	subscription onUpdateAdvisorPayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateAdvisorPayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			locationId
			name
			position
			default {
				...AdvisorDefault
			}
			followUpPerformanceBonus {
				...FollowUpPerformanceBonus
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			customerSatisfaction {
				...CustomerSatisfaction
			}
			longevity {
				...Longevity
			}
			retentionPay {
				...Retention
			}
			holidayPay {
				...HolidayPay
			}
			topAdvisorsBonus {
				...TopPerformerBonus
			}
			elr {
				...ELRAndHROBonus
			}
			hro {
				...ELRAndHROBonus
			}
			locked
			available
			createdAt
			createdBy {
				_id
				fullName
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
	${AdvisorDefaultFragment}
	${CallActivityPerformanceFragment}
	${CommissionTiersFragment}
	${CustomerSatisfactionFragment}
	${FollowUpPerformanceBonusFragment}
	${LongevityFragment}
	${InputValueFragment}
	${MetricFragment}
	${TopPerformerBonusFragment}
	${ELRAndHROBonusFragment}
	${RetentionFragment}
	${HolidayPayFragment}
`;
